import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close as CloseIcon } from "@mui/icons-material";
import { Box, Dialog, IconButton } from "@mui/material";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { useIconButtonDarkStyles } from "../button/useIconButtonStyles.js";
import { useModalStack } from "../modal/ModalStack.js";
import { inverseTheme } from "../Theme.js";
export function BackdropModal({ handleClose, notInStack, onTopChange, children, }) {
    const { isTop } = useModalStack(notInStack, onTopChange);
    return (_jsx(MuiThemeProvider, { theme: inverseTheme, children: _jsx(Dialog, { open: true, onClose: (event, reason) => {
                if (reason === "backdropClick")
                    return;
                handleClose();
            }, onClick: e => e.stopPropagation(), fullScreen: true, fullWidth: true, style: { display: isTop ? "block" : "none" }, BackdropProps: {
                sx: { background: "rgba(0, 0, 0, 0.8)" },
            }, PaperProps: {
                variant: "elevation",
                elevation: 0,
                sx: { background: "none" },
            }, children: _jsxs(Box, { sx: {
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                }, children: [children, _jsx(Box, { display: "flex", position: "absolute", left: "8px", top: "8px", zIndex: 2, children: _jsx(CloseButton, { onClick: handleClose }) })] }) }) }));
}
const CloseButton = ({ onClick }) => {
    const { classes } = useIconButtonDarkStyles();
    return (_jsx(IconButton, { classes: classes, color: "secondary", onClick: onClick, "aria-label": "Close", size: "large", children: _jsx(CloseIcon, {}) }));
};
//# sourceMappingURL=BackdropModal.js.map